import React from 'react';

const UserDeviceSettingsContext = React.createContext({});

export default UserDeviceSettingsContext;
